<div class="d-flex flex-column align-items-center">
  <h1 class="mt-4">Página não encontrada</h1>
  <a routerLink="/inicio" mat-raised-button color="primary" class="mt-4">VOLTAR AO INÍCIO</a>
</div>
